/** @graphql cc **/

import gql from 'graphql-tag';

/*
A problem exists with the Babel compiler where updating fragments does not refresh the cache.
When altering this fragment, make sure to include a comment to clear the cache for the primary queries that rely on this fragment.
Add the comment "*comment to invalidate cache*" to achieve this.

Refer to this example: https://sourcegraph-frontend.internal.shared-prod.us-west-2.kitt-inf.net/stash.atlassian.com/ATLASSIAN/atlassian-frontend-monorepo/-/blob/confluence/next/packages/whiteboard-common/src/graphql/WhiteboardUnifiedQuery.graphql.ts?L5
*/

export const WhiteboardUnifiedQuery = gql`
	query WhiteboardUnifiedQuery($contentId: ID!, $spaceKey: String, $contentVersion: Int!) {
		content(id: $contentId) {
			nodes {
				id
				referenceId
				title
				operations {
					operation
					targetType
				}
				hasRestrictions
				hasViewRestrictions
				hasInheritedRestrictions
				space {
					id
					name
					key
					type
					alias
				}
				type
				status
				ancestors {
					id
					type
					title
					status
				}
				metadata {
					currentuser {
						favourited {
							isFavourite
						}
					}
					lastModifiedDate
				}
				properties(keys: ["import-source", "imported-page-modified-date"]) {
					nodes {
						key
						value
					}
				}
				history {
					createdBy {
						... on KnownUser {
							accountId
						}
						... on UnknownUser {
							accountId
						}
					}
				}
			}
		}
		spaces(spaceKey: $spaceKey, first: 10) {
			nodes {
				id
				name
				homepage {
					id
				}
			}
		}
		user: confluence_atlassianUser(current: true) {
			id
			confluence {
				space {
					id
				}
			}
		}
		paywallStatus(id: $contentId)
		canvasToken(contentId: $contentId) {
			token
		}
		contentMediaSession(contentId: $contentId) {
			accessTokens {
				readOnlyToken {
					value
				}
				readWriteToken {
					value
				}
			}
			configuration {
				fileStoreUrl
			}
		}
		entitlements {
			whiteboardFeatures {
				smartConnectors {
					isEntitled
				}
				smartSections {
					isEntitled
				}
			}
		}
		dataSecurityPolicy {
			isActionEnabledForContent(
				action: PAGE_EXPORT
				contentId: $contentId
				contentStatus: CURRENT
				spaceKey: $spaceKey
				contentVersion: $contentVersion
			) {
				allowed
			}
		}
	}
`;
